const indowWindowStyles = `
  .full-container {
    padding: 16px;

    width: 344px;
  }

  .header {
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e5e5;
  }

  .header--title {
    font: 700 16px/150% 'Open Sans', sans-serif;
    color: #793EAD;
  }

  .body-container {
    padding: 16px 0 24px 0;
    font: 400 14px/150% 'Open Sans', sans-serif;
  }

  .body-container--info {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .info-container {
    display: flex;
    justify-content: space-between;

    height: 21px;

    font-size: 14px;
  }

  .info-container p {
    margin: 0;
  }

  .infowindow-button {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 12px 24px;
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: none;

    font: 700 16px/100% 'Quicksand', sans-serif;
    color: #fff;

    background: #793EAD;

    cursor: pointer;
  }

  .infowindow-button:hover {
    transition: 0.2s;
    background-color: #3f205a;
  }
`;

export default indowWindowStyles;
